import { Guid } from "@/Common/Models/Guid";
import { GetPrescriptionRenewalByIdResponse } from "../Api/Dto/GetPrescriptionRenewalByIdResponse";
import { PrescriptionRenewalStatus } from "../Common/PrescriptionRenewalStatus";
import { PrescriptionRenewalMedications } from "./PrescriptionRenewalMedications";

class PrescriptionRenewalsViewModel {
    public documentId: Guid | null;
    public documentByteId: Guid | null;
    public isUrgent: boolean;
    public relatedPrescriptionRenewalMedications: PrescriptionRenewalMedications[] | null;
    public status: PrescriptionRenewalStatus;
    public notes: string;
    public senderFaxNumber: string | null;

    public static fromResponseModel(prescriptionRenewalByIdResponse: GetPrescriptionRenewalByIdResponse): PrescriptionRenewalsViewModel {
        if (!prescriptionRenewalByIdResponse)
            return null;

        return {
            documentId: prescriptionRenewalByIdResponse.DocumentId,
            documentByteId: prescriptionRenewalByIdResponse.DocumentByteId,
            isUrgent: prescriptionRenewalByIdResponse.IsUrgent,
            relatedPrescriptionRenewalMedications: prescriptionRenewalByIdResponse.RelatedPrescriptionRenewalMedications?.map(p => PrescriptionRenewalMedications.fromResponseModel(p)),
            status: prescriptionRenewalByIdResponse.Status,
            notes: prescriptionRenewalByIdResponse.Notes,
            senderFaxNumber: prescriptionRenewalByIdResponse.SenderFaxNumber
        };
    }
}

export { PrescriptionRenewalsViewModel };
